module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "id": "audio-preview",
      "width": "50%",
      "title": "Audio Preview",
      "destroy-on-close": "",
      "visible": _vm.internalVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.internalVisible = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.note) ? _c('div', [_c('div', {
    staticClass: "modal-meta"
  }, [_c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.sender))])]), _vm._v(" "), (_vm.note.location) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-location"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.note.location))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "meta-item"
  }, [_c('i', {
    staticClass: "el-icon-time"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formatDate(_vm.note.timestamp)))])]), _vm._v(" "), (_vm.note.score) ? _c('div', {
    staticClass: "meta-item"
  }, [_c('el-rate', {
    attrs: {
      "value": _vm.note.score,
      "disabled": "",
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
      "text-color": "#ff9900"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "meta-badges"
  }, [(_vm.note.approved) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "success",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" On Air\n        ")]) : _vm._e(), _vm._v(" "), (_vm.note.flagged) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "danger",
      "effect": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" Flagged\n        ")]) : _vm._e(), _vm._v(" "), (_vm.note.tone) ? _c('el-tag', {
    attrs: {
      "size": "mini",
      "type": "info"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.capitalize(_vm.note.tone)) + "\n        ")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.note.audioUrl) ? _c('div', {
    staticClass: "audio-player"
  }, [_c('audio', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls": "",
      "src": _vm.note.audioUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" Transcript ")]), _vm._v(" "), _c('el-card', {
    staticClass: "transcript-card",
    attrs: {
      "shadow": "never"
    }
  }, [_c('span', {
    staticClass: "transcript-text"
  }, [_vm._v(_vm._s(_vm.note.transcript || 'No transcript available.'))])]), _vm._v(" "), (_vm.note.tags && _vm.note.tags.length) ? _c('div', {
    staticClass: "meta-section"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-collection-tag"
  }), _vm._v(" Tags\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.note.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "size": "mini",
        "type": "warning",
        "effect": "plain"
      }
    }, [_vm._v(_vm._s(tag))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.note.people && _vm.note.people.length) ? _c('div', {
    staticClass: "meta-section"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" People Mentioned\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.note.people), function(person) {
    return _c('el-tag', {
      key: person,
      attrs: {
        "size": "mini",
        "type": "info",
        "effect": "plain"
      }
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(" " + _vm._s(person) + "\n        ")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.note.keywords && _vm.note.keywords.length) ? _c('div', {
    staticClass: "meta-section"
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('i', {
    staticClass: "el-icon-price-tag"
  }), _vm._v(" Keywords\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.note.keywords), function(keyword) {
    return _c('el-tag', {
      key: keyword,
      attrs: {
        "size": "mini",
        "type": "success",
        "effect": "plain"
      }
    }, [_vm._v(_vm._s(keyword))])
  }), 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("Close")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8d8a3b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/modals/AudioPreviewModal.vue
// module id = 3304
// module chunks = 3